import font from '@assets/fonts/TTNormsProVariable.ttf';
import italicTTNorms from '@assets/fonts/TTNormsProItalic.otf';

export default {
  '@font-face': [
    {
      fontFamily: 'TTNorms',
      src: `url("${font}")`,
    },
    { fontFamily: 'TTNorms', src: `url(${italicTTNorms})`, fontStyle: 'italic' },
  ],
  body: {
    fontFamily: 'TTNorms, Helvetica, Arial, sans-serif',
    margin: '0',
    display: 'flex',
    minHeight: '100vh',
    // .text class styles
    fontWeight: '$regular',
    fontSize: '$md',
    lineHeight: '$6',
  },
  '*': {
    fontFamily: 'TTNorms',
    boxSizing: 'border-box',
  },
  h1: {
    fontWeight: '$bold',
    fontSize: '$2xl',
    lineHeight: '$8',
  },
  h2: {
    fontWeight: '$bold',
    fontSize: '$xl',
    lineHeight: '$6',
  },
  '@md': {
    h1: {
      fontSize: '$3xl',
      lineHeight: '$10',
    },
    h2: {
      fontSize: '$2xl',
      lineHeight: '$8',
    },
  },
  h3: {
    fontWeight: '$medium',
    fontSize: '$lg',
    lineHeight: '$6',
  },
  '.text': {
    fontSize: '$md',
    lineHeight: '$6',
  },
  '.text-sm': {
    fontSize: '$sm',
    lineHeight: '$6',
  },
  '.text-xs': {
    fontSize: '$xs',
    lineHeight: '$4',
  },
  '.breadcrumb': {
    textTransform: 'uppercase',
    fontWeight: '$regular',
    fontSize: '$sm',
    lineHeight: '$4',
    letterSpacing: '$0',
  },
  '.font-medium': {
    fontWeight: '$medium',
  },
  '.font-bold': {
    fontWeight: '$bold',
  },
  '.font-italic': {
    fontStyle: 'italic',
    fontVariationSettings: '"slnt" 12',
  },
};
